/**
 * Calculates the total gross amount for a given base (net or gross) amount.
 *
 * @param amount The base amount:
 * 	- if isTaxIncluded = false, this is the net amount (before tax)
 *  - if isTaxIncluded = true, this is the gross amount (including tax)
 * @param taxRate The tax rate as a percentage (e.g. 19 for 19%).
 * @param isTaxIncluded Whether `amount` already includes tax (gross). Defaults to false.
 * @returns The gross amount.
 * @example
 * ```ts
 * const amount = 400;
 * const taxRate = 19;
 * const isTaxIncluded = true;
 * const totalGross = amountToTotalGross(amount, taxRate, isTaxIncluded);
 * console.log(totalGross); // Output: 400
 * ```
 * @example
 * ```ts
 * const amount = 400;
 * const taxRate = 19;
 * const isTaxIncluded = false;
 * const totalGross = amountToTotalGross(amount, taxRate, isTaxIncluded);
 * console.log(totalGross); // Output: 476
 * ```
 */
export function amountToTotalGross(
	amount: number,
	taxRate: number,
	isTaxIncluded?: boolean | null,
): number {
	// Sanitize
	const base = isNaN(amount) ? 0 : amount;
	const rate = isNaN(taxRate) ? 0 : taxRate;

	// If amount already includes tax, just return it, otherwise add tax to the base amount
	return isTaxIncluded ? base : base * (1 + rate / 100);
}
